import { onErrorDefault } from '@occc-app/dataAccessLayer/utils';
import {
  RetailerNetworkTobaccoProgramMetricTimeSeriesFilter,
  RetailerNetworkTobaccoProgramMetricType,
  useRetailerNetworkTobaccoProgramMetricTimeSeriesQuery,
} from '@occc/graphql';

export const useRetailerNetworkTobaccoProgramMetricTimeSeries = (
  metricType: RetailerNetworkTobaccoProgramMetricType,
  filter: RetailerNetworkTobaccoProgramMetricTimeSeriesFilter,
) => {
  return useRetailerNetworkTobaccoProgramMetricTimeSeriesQuery({
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
    onError: onErrorDefault,
    variables: {
      filter,
      metricType,
    },
  });
};
